document.addEventListener('turbolinks:load', function() {
  if ($('main > .adsbygoogle').length > 0) {
    (adsbygoogle = window.adsbygoogle || []).push({});
  };
});

$(document).on('turbolinks:before-cache', function() {
  $('main > .adsbygoogle *').remove();
});
